import Input from "components/foundation/Input/Input";
import React, { useState } from "react";

import { PasswordVerificationBoard } from "./styles";
import Button from "components/foundation/Button";
import { useFormContext } from "react-hook-form";
import Modal from "components/foundation/Modal/Modal";
import useVerifyPasswordMutation from "features/my-page/mutations/useVerifyPasswordMutation";

interface FormData {
  password: string;
}

interface PasswordVerificationCardProps {
  onSuccess: () => void;
}

const PasswordVerificationCard = ({
  onSuccess,
}: PasswordVerificationCardProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useFormContext<FormData>();
  const [isInvalidModalOpen, setIsInvalidModalOpen] = useState(false);
  const { mutate } = useVerifyPasswordMutation();

  const passwordValidationSubmit = (data: FormData) => {
    mutate(data, {
      onSuccess: () => {
        onSuccess();
      },
      onError: () => {
        setIsInvalidModalOpen(true);
      },
    });
  };

  return (
    <>
      <Modal.Root
        open={isInvalidModalOpen}
        onOpenChange={setIsInvalidModalOpen}
      >
        <Modal.Body
          title="비밀번호가 일치하지 않습니다."
          onConfirm={() => {
            setIsInvalidModalOpen(false);
          }}
        ></Modal.Body>
      </Modal.Root>
      <form onSubmit={handleSubmit(passwordValidationSubmit)}>
        <PasswordVerificationBoard isShadow>
          <div className="password-verification__header">
            <h1>비밀번호를 다시 한 번 입력해 주세요.</h1>
            <h2>개인정보 보호를 위해 비밀번호를 다시 입력해야 합니다.</h2>
          </div>
          <Input
            type="password"
            placeholder="비밀번호를 입력해주세요."
            {...register("password", {
              required: "8자이상 20자 이하로 입력이 필요합니다.",
              minLength: {
                value: 8,
                message: "8자이상 20자 이하로 입력이 필요합니다.",
              },
            })}
            maxLength={20}
            errorMessage={errors.password?.message}
          />
          <Button size="large" type="submit">
            확인
          </Button>
        </PasswordVerificationBoard>
      </form>
    </>
  );
};

export default PasswordVerificationCard;
